import { Grid } from "@mui/material";
import classes from "./EnglishFormActionSection.module.css";

const EnglishFormActionSection = ({
  fromDraft,
  observe,
  cancelHandler,
  submitFormHandler,
  updateFormHandler,
  deleteFormHandler,
  edit,
}) => {
  const renderValue = (
    <>
      {observe ? (
        <Grid container item xs={11} sm={12} className={classes.formSubmitContainer}>
          <button className={classes.cancelBtn} onClick={cancelHandler}>
            Cancel
          </button>
        </Grid>
      ) : !edit ? (
        <Grid container item xs={11} sm={12} className={classes.formSubmitContainer}>
          <button className={classes.cancelBtn} onClick={cancelHandler}>
            {!submitFormHandler && !updateFormHandler ? "Return" : "Cancel"}
          </button>
          {submitFormHandler ? (
            <button className={classes.submitBtn} type="submit" onClick={submitFormHandler}>
              Save
            </button>
          ) : null}
        </Grid>
      ) : (
        <Grid container item xs={11} sm={12} className={classes.formSubmitContainer} sx={{ mt: 3 }}>
          {/* <button className={classes.deleteBtn} type="submit" onClick={deleteFormHandler}>
            Delete
          </button> */}
          <button className={classes.cancelBtn} onClick={cancelHandler}>
            Close
          </button>
          {updateFormHandler ? (
            <button className={classes.submitBtn} type="submit" onClick={updateFormHandler}>
              Update
            </button>
          ) : null}
        </Grid>
      )}
    </>
  );

  return renderValue;
};

export default EnglishFormActionSection;
